import dayjs from "dayjs";
import { boxHeight, monthWidth } from "../../constants";
import { Day } from "../../types/global";
import { Theme } from "../../styles";
import { drawCell } from "./drawCell";

export const drawYearlyMonthView = (
  ctx: CanvasRenderingContext2D,
  rows: number,
  cols: number,
  startDate: Day,
  theme: Theme
) => {
  let xPos = 0;
  // let startPos = -(startDate.dayOfMonth - 1) * singleDayWidth;
  for (let i = 0; i <= cols-1; i++) {
    const month = dayjs(`${startDate.year}-${startDate.month + 1}`).add(
      i,
      "month"
    );
    
    const isCurrWeek = month.isSame(dayjs(), "month");
    for (let y = 0; y < rows; y++) {
      drawCell(ctx, xPos, y * boxHeight, monthWidth, true, isCurrWeek, false, theme);
    }
    
    xPos += monthWidth;
  }
  
  // for (let i = 0; i < cols; i++) {
  //   const width = getDaysInMonths(startDate, i) * singleDayWidth;
  //   drawDashedLine(ctx, startPos, rows * boxHeight, theme);
  //   startPos += width;
  // }
};
